import React  from 'react'

import FormManager from "../../../../../../../core/gd-form/common/form-manager"
import FormAdd from "../../../../../../../core/gd-form/form/form-add/form-add"
import VScroll from "../../../../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll"
import FormActions from "../../../../../../../core/gd-form/form/form-ui5/actions"

// @ts-ignore
import FormModal from "../../../../../../../core/gd-form/form/form-modal/form-modal"

type Props = {
    className?  : string
    style?      : any

    mode        : 'create' | 'update'
    form        : FormManager

    children?   : any
}

export default function CommonForm(props: Props) {

    let Form: any = FormAdd
    let submitLabel = 'Submit'
    if (props.mode === 'update') {
        submitLabel = 'Save'
        Form = FormModal
    }

    return (
        <Form className={props.className} style={props.style} form={props.form} showSubmit={false} submitButton={false}>
            <VScroll>
                {props.children}
            </VScroll>
            <div className="modal-submit">
                <FormActions form={props.form} submitLabel={submitLabel}/>
            </div>
        </Form>
    )
}